import React, { useState } from 'react';
import { ChevronDown, Database, Cloud, Loader2, ShieldCheck, Download } from 'lucide-react';
import createAndDownloadBackup from '../../utils/backupDownload';
import toast from 'react-hot-toast';

const fmtTime = (iso) => {
  if (!iso) return 'Never';
  const d = new Date(iso);
  if (isNaN(d)) return '—';
  const today = new Date();
  const sameDay = d.toDateString() === today.toDateString();
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  return `${sameDay ? 'Today' : d.toLocaleDateString()}, ${time}`;
};

function statusOf(backups, type) {
  const b = backups.find(x => x.backup_type === type) || backups[0];
  if (!b) return { status: 'pending', time: 'Never', text: 'Pending' };
  const status = (b.status || '').toLowerCase();
  const s = status.includes('fail') ? 'failed' : status.includes('complet') || status.includes('success') ? 'ok' : 'pending';
  return { status: s, time: fmtTime(b.created_at), text: s === 'ok' ? 'Successful' : s === 'failed' ? 'Failed' : 'Pending' };
}

/**
 * BACKUP STATUS — collapsible status panel showing local and online
 * backup times with green/orange/red status, plus a Back Up Now action.
 */
export default function BackupStatusPanel({ backups, onRefresh, busy, setBusy }) {
  const [open, setOpen] = useState(true);
  const local = statusOf(backups, 'Manual');
  const online = statusOf(backups, 'Online');

  const handleBackup = async () => {
    setBusy(true);
    try {
      await createAndDownloadBackup('Manual');
      toast.success('Backup created and downloaded');
      if (onRefresh) onRefresh();
    } catch (err) {
      toast.error(err.message || 'Backup failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="desk-status-section">
      <button type="button" className={`desk-status-toggle ${open ? '' : 'collapsed'}`} onClick={() => setOpen(o => !o)}>
        <ChevronDown /> Backup Status
      </button>
      {open && (
        <div className="desk-status-body">
          <div className="desk-backup-row">
            <Database /> <span className="desk-backup-name">Local Backup:</span>
            <span className="desk-backup-time">{local.time}</span>
            <span className={`desk-backup-status ${local.status}`}>{local.text}</span>
          </div>
          <div className="desk-backup-row">
            <Cloud /> <span className="desk-backup-name">Online Backup:</span>
            <span className="desk-backup-time">{online.time}</span>
            <span className={`desk-backup-status ${online.status}`}>{online.text}</span>
          </div>
          <button type="button" className="desk-backup-btn" disabled={busy} onClick={handleBackup}>
            {busy ? <Loader2 size={13} className="spin-slow" /> : <ShieldCheck size={13} />}
            {busy ? 'Backing up…' : 'Back Up Now'}
          </button>
        </div>
      )}
    </section>
  );
}
